import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { AvantoRestaurantsService } from 'src/app/services/avanto-restaurants.service';
import { ScrollFunctions } from '../../../../util/ScrollFunctions';
import * as $ from 'jquery';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';

@Component({
  selector: 'all-categories-mobilebar',
  templateUrl: './all-categories-mobilebar.component.html',
  styleUrls: ['./all-categories-mobilebar.component.scss']
})
export class AllCategoriesMobileBarComponent implements OnInit, OnDestroy {
  private sessionObserver: Subscription;
  private selectedMenuSubscription: Subscription;

  categoryTitles: MobileCategoryTitle[];
  selectedCategoryIndex;
  isAutomaticMobileBarScrollLocked = false;
  isDelivery:boolean;

  @HostListener("window:scroll", []) onWindowScroll() {
    if (!this.isAutomaticMobileBarScrollLocked && $("#mobileBarElements").is(":visible")) {
      // do some stuff here when the window is scrolled
      const verticalOffset = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop || 0;

      const mobileBarHeightOffset = 85;
      let viewedElementIndex = 0;

      if (this.categoryTitles.length > 0) {
        for (let i = 0; i < this.categoryTitles.length; i++) {
          if((this.isDelivery && this.categoryTitles[i].displayForDelivery) || (!this.isDelivery && this.categoryTitles[i].displayForPickup)){
            const titleOffset = $("#" + this.categoryTitles[i].id).offset().top - mobileBarHeightOffset;
            if (titleOffset <= verticalOffset) {
              viewedElementIndex = i
            } else {
              break;
            }
          }
        }
      }
      if (this.selectedCategoryIndex != viewedElementIndex) {
        this.selectedCategoryIndex = viewedElementIndex;
        ScrollFunctions.horizontalScrollToIdInDiv("mobileBarElements", "mobileBarElements-left-anchor", "mobileBar-" + this.categoryTitles[viewedElementIndex].id, 0);
      }
    }

  }

  constructor(private restaurantsService: AvantoRestaurantsService, private avantoSession:AvantoSessionService) { }

  ngOnInit() {
    this.categoryTitles = [];
    this.selectedCategoryIndex = 0;

    this.selectedMenuSubscription = this.restaurantsService.subject_selectedRestaurant.subscribe(restaurant => {
      this.categoryTitles = [];
      restaurant.categories.forEach(cat => {
        const dForPickup   = cat.shouldDisplay!=null?cat.shouldDisplay.displayForPickup:true;
        const dForDelivery = cat.shouldDisplay!=null?cat.shouldDisplay.displayForDelivery:true;
        this.categoryTitles.push(new MobileCategoryTitle(cat.title, cat.id, false, dForPickup, dForDelivery));

        cat.subCategories.forEach((subCat) => {
          const subCatDisplayForPickup   = subCat.shouldDisplay!=null?subCat.shouldDisplay.displayForPickup:true;
          const subCatDisplayForDelivery = subCat.shouldDisplay!=null?subCat.shouldDisplay.displayForDelivery:true;
          this.categoryTitles.push(new MobileCategoryTitle(subCat.title, subCat.id, true,subCatDisplayForPickup,subCatDisplayForDelivery));
        })
      })
    });

    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      this.isDelivery = session.orderType == SessionObject.ORDER_TYPE_DELIVERY;
    });
  }

  ngOnDestroy() {
    this.selectedMenuSubscription.unsubscribe();
    this.sessionObserver.unsubscribe();
  }

  /** Scrollls the screen to a specific element, based on it's ID */
  scrollToElement(index, elementId, isSubCatOffset?) {
    //I lock the automatic mobile bar scrolling (the one that happens when I scroll up and down the page)
    // until the window is scrolled. this prevent the mobile bar from going crazy while the screen is moving.
    this.isAutomaticMobileBarScrollLocked = true;

    //== Scrolls the window to the selected element ==
    this.selectedCategoryIndex = index;
    //  We are giving a -60px offset because of the bar on the top of the page that is screwing things over
    const offset = isSubCatOffset ? -85 : -65;
    ScrollFunctions.scrollToId(elementId, offset).then(()=>{this.isAutomaticMobileBarScrollLocked = false;});
    //== Scrolls the mobile bar to the right place
    // ScrollFunctions.horizontalScrollToIdInDiv("mobileBarElements", "mobileBarElements-left-anchor", "mobileBar-" + elementId, 0);
  }
}

// Stores a category title and it's category's ID
// Used for navigation purposes
export class MobileCategoryTitle {
  title: string;
  id: string;
  isSubCat: boolean;
  displayForPickup:boolean;
  displayForDelivery:boolean;

  constructor(title: string, id: string, isSubCat: boolean, displayForPickup:boolean, displayForDelivery:boolean){
    this.title = title;
    this.id = id;
    this.isSubCat = isSubCat;
    this.displayForPickup = displayForPickup;
    this.displayForDelivery = displayForDelivery;
  }
}